import { Location } from 'history';
import { createStandardAction } from 'typesafe-actions';

const changeLocation = createStandardAction('@lib/changeLocation')<Location>();

export default changeLocation;
